/* global React, Card, Button, Modal, t */

function ImportedComplianceNotice({year,area}){
  const backend=window.PlummeBackend?.useBackend?window.PlummeBackend.useBackend():null;
  const state=backend?.appState||window.PlummeBackend?.appState||{};
  const yearKey=String(year||state.activeYear||'');
  const compliance=state.accountingImportComplianceByYear?.[yearKey];
  const acknowledged=Boolean(state.accountingImportComplianceNotices?.[yearKey]?.[area]?.acknowledgedAt);
  const [open,setOpen]=React.useState(()=>Boolean(compliance&&!acknowledged));
  React.useEffect(()=>setOpen(Boolean(compliance&&!acknowledged)),[yearKey,area,Boolean(compliance),acknowledged]);
  if(!compliance)return null;

  const areaLabel=t('importCompliance.area.'+area);
  const decisionKey={vat:'vatReturns',tax:'taxReturn',annualAccounts:'annualAccounts',yearClosing:'yearClosing'}[area];
  const deadline=state.deadlinesByYear?.[yearKey]||{};
  const currentDecision={
    yearClosing:Boolean(state.closedYearsByYear?.[yearKey]||deadline.annualClosingSubmitted)?'delivered':'open',
    taxReturn:deadline.taxSubmitted?'delivered':'open',
    annualAccounts:deadline.annualAccountsSubmitted?'delivered':'open',
    vatReturns:(deadline.mvaSubmitted||Object.values(deadline.mvaTerms||{}).some(Boolean))?'delivered':'open',
  }[decisionKey]||compliance.decisions?.[decisionKey];
  const importedDecision=compliance.decisions?.[decisionKey]==='not-applicable'?'not-applicable':currentDecision;
  const statusText=importedDecision==='delivered'
    ? t('importCompliance.statusDelivered',{area:areaLabel,status:t(area==='yearClosing'?'importCompliance.statusClosed':'importCompliance.statusFiled')})
    : importedDecision==='not-applicable'
      ? t('importCompliance.statusNotApplicable',{area:areaLabel})
      : t('importCompliance.statusOpen',{area:areaLabel});
  const acknowledge=()=>{
    setOpen(false);
    window.PlummeBackend?.updateState?.((current)=>({
      ...current,
      accountingImportComplianceNotices:{
        ...(current.accountingImportComplianceNotices||{}),
        [yearKey]:{
          ...(current.accountingImportComplianceNotices?.[yearKey]||{}),
          [area]:{acknowledgedAt:new Date().toISOString()},
        },
      },
    }),true);
  };
  const content=<React.Fragment>
    <p style={{margin:'0 0 8px'}}>{statusText}</p>
    <p className="muted" style={{margin:0}}>{t('importCompliance.noticeBody')}</p>
  </React.Fragment>;
  return <React.Fragment>
    <Card style={{marginBottom:18,borderColor:'var(--warning-bd,var(--border))',background:'var(--warning-bg,#fff7e6)'}}>
      <div className="t-sm" style={{fontWeight:900,marginBottom:6}}>{t('importCompliance.noticeTitle',{year:yearKey})}</div>{content}
    </Card>
    {open&&<Modal open onClose={acknowledge} title={t('importCompliance.noticeTitle',{year:yearKey})} max={600} footer={<Button onClick={acknowledge}>{t('importCompliance.understood')}</Button>}><div className="t-sm">{content}</div></Modal>}
  </React.Fragment>;
}

window.ImportedComplianceNotice=ImportedComplianceNotice;
